import FolderRounded from '@mui/icons-material/FolderRounded';
import InsertDriveFileOutlined from '@mui/icons-material/InsertDriveFileOutlined';
import * as React from 'react';
import { Instrument } from '../../../ledger/ledgerInstrument';
import './InstrumentGlyph.scss';

export type InstrumentGlyphProps = {
  instrument: Pick<Instrument, 'kind' | 'glyph'>;
};

/**
 * The Consolidation Ledger's instrument glyph: M, OS, A, S, C, a dashed ? — or
 * an icon for a plain file or a folder, which have no letter of their own.
 */
export const InstrumentGlyph: React.FC<InstrumentGlyphProps> = ({
  instrument,
}) => {
  const className = `tree-ledger-glyph tree-ledger-glyph--${instrument.kind}`;

  if (instrument.kind === 'folder') {
    return <FolderRounded className={className} aria-hidden />;
  }
  if (instrument.kind === 'file') {
    return <InsertDriveFileOutlined className={className} aria-hidden />;
  }
  return (
    <span className={className} aria-hidden="true">
      {instrument.glyph}
    </span>
  );
};
